import { render, staticRenderFns } from "./ComposeWizard.vue?vue&type=template&id=30592e1e&"
import script from "./ComposeWizard.vue?vue&type=script&lang=js&"
export * from "./ComposeWizard.vue?vue&type=script&lang=js&"
import style0 from "./ComposeWizard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports